/**
 * Sorts an array ('array'), first by an array of numbers or strings ('primarySortArray')
 * that refers to values in 'primarySortField', and then ascending by a string field ('secondarySortField').
 * Items matching the value of 'lastId' are placed at the end of the returned array,
 * sorted by 'secondarySortField' among themselves.
 * Written to sort functions and tasks by function rank, but can be used for other purposes.
 *
 * Lives in its own module (rather than next to the selectors that use it) so it can be
 * imported — and unit tested — without pulling in the store selector barrel.
 */
export function sortByArrayAndField<T>(
  array: T[],
  primarySortArray: unknown[],
  primarySortField: string,
  secondarySortField: string,
  lastId: string | number,
): T[] {
  const result = array
    .filter((f) => f[primarySortField] !== lastId)
    .sort((a, b) => {
      let indexA = primarySortArray.indexOf(a[primarySortField] ?? 0);
      let indexB = primarySortArray.indexOf(b[primarySortField] ?? 0);
      if (indexA === -1 && indexB === -1) {
        return (a[secondarySortField] ?? '').localeCompare(b[secondarySortField] ?? '');
      }
      if (indexA === -1) indexA = Infinity;
      if (indexB === -1) indexB = Infinity;
      return indexA - indexB;
    });
  const common = array
    .filter((f) => f[primarySortField] === lastId)
    .sort((a, b) => (a[secondarySortField] ?? '').localeCompare(b[secondarySortField] ?? ''));
  result.push(...common);
  return result;
}
